import React, {Component, PropTypes} from 'react';
import $ from 'jquery';
import {apiRoutes, get} from './../../../api/api';
import Tag from './Tag';
import stringHelper from '../../../helpers/stringHelper';
import {debounce} from '../../../helpers/rateHelper';

class TagsSuggest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResults: [],
      highlighted: -1,
      loading: false,
      open: false,
      userInput: '',
    };

    this._blur = true;

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleTyping = this.handleTyping.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.renderResults = this.renderResults.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.addTag = this.addTag.bind(this);
    this.removeTag = this.removeTag.bind(this);
    this.handeContainerClick = this.handeContainerClick.bind(this);
    this.search = this.search.bind(this);

    this.debouncedSearch = debounce(this.search, 300, false);

    this.nextSearch = null;
  }

  open() {
    this.setState({open: true});
  }

  close() {
    this.setState({open: false, userInput: '', searchResults: []});

  }

  // menu
  handleMouseLeave() {
    this.setState({highlighted: -1});
  }

  // item
  handleMouseEnter(event) {
    this.setState({highlighted: parseInt(event.target.id)});
  }

  // item
  handleMouseDown() {
    this._blur = false;
  }

  // item
  handleSelectItem(item) {
    const {input} = this.refs;

    if (item) {
      this.addTag(item.attributes.label);
    }

    setTimeout(() => {
      input.focus();
      input.value = "";
      this.setState({searchResults: []});
      this._blur = true;
      this.close();
    });

    this.close();
  }

  // children
  // children
  handleFocus(event) {
    const {onFocus} = this.props;
    $(event.target).parent().addClass('active');


    this.open();
    onFocus && onFocus(event);
  }

  // children
  handleBlur(event) {
    const {onBlur} = this.props;
    if (!this._blur) return;

    $(event.target).parent().removeClass('active');
    this.close();
    onBlur && onBlur(event);
  }

  // children
  handleKeyDown(event) {
    const {highlighted, searchResults} = this.state;
    this.open();

    let next = Math.min(highlighted + 1, searchResults.length - 1);
    let prev = Math.max(highlighted - 1, -1);

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.setState({highlighted: next});
        return;

      case 'ArrowUp':
        event.preventDefault();
        this.setState({highlighted: prev});
        return;

      case 'Enter':
        event.preventDefault();
        if (highlighted > -1 && this.state.open) {
          this.handleSelectItem(searchResults[highlighted]);
        }
        else {
          this.props.onEnter();
        }
        return;

      case 'Escape':
        this.close();
        return;

      default:

        setTimeout(() => this.forceUpdate());
        return;
    }
  }

  search(text) {
    this.setState({loading: true});
    get(apiRoutes.autocomplete.tags(), function (result) {
      if (result.data) {
        this.setState({
          highlighted: -1,
          searchResults: result.data.map(function (entry) {
            return {id: entry.id, attributes: entry.attributes};
          }),
        });
      } else {
        this.setState({
          highlighted: -1,
          searchResults: []
        });
      }
      this.setState({loading: false});
    }.bind(this), null, {query: text});
  }


  handleTyping(event) {
    let text = event.target.value;
    if (text) {
      if (this.nextSearch) {
        clearTimeout(this.nextSearch);
        this.nextSearch = null;
      }
      this.nextSearch = this.debouncedSearch(text);
      this.setState({userInput: text});
    } else {
      if (this.nextSearch) {
        clearTimeout(this.nextSearch);
        this.nextSearch = null;
      }
      this.setState({
        searchResults: [],
        userInput: ''
      });
    }
  }

  renderResults() {
    let {loadingContent} = this.props;
    let {highlighted, loading, searchResults} = this.state;
    if (loading) {
      return loadingContent || React.DOM.li(null, "Loading results..");
    }
    return searchResults.slice(0, 7).map((one, i) => {
      const isHighlighted = highlighted === i;
      let listitem = (<li key={i} id={i} onClick={() => {
        this.handleSelectItem(searchResults[i]);
      }} onMouseDown={this.handleMouseDown} onMouseEnter={this.handleMouseEnter}
                          onMouseLeave={this.handleMouseLeave}>
        <span id={i} dangerouslySetInnerHTML={{__html: one.attributes.preview}}/>
      </li>);
      if (isHighlighted) {
        return (<em key={i}>{listitem}</em>);
      }
      return listitem;
    });
  }

  removeTag(tag) {
    let {tags, onTagsChanged} = this.props;
    let index = tags.indexOf(tag);

    if (index !== -1) {
      tags.splice(index, 1);
    }

    onTagsChanged(tags);
  }

  addTag(data) {
    let {tags, onTagsChanged} = this.props;

    if (Array.isArray(data)) {
      tags = tags.concat(data);
    } else {
      tags.push(data);
    }
    onTagsChanged(tags);
  }

  handeContainerClick() {
    this.refs.input.focus();
  }

  render() {
    let {searchResults, open, userInput} = this.state;
    let {tags} = this.props;
    let {renderResults, removeTag, handeContainerClick, handleBlur, handleFocus, handleKeyDown, handleTyping} = this;
    let dropdownresults = (<div></div>);
    if (searchResults.length > 0) {
      dropdownresults = (<ul className="autoSuggestDropdown"> {open && renderResults()}</ul>);
    }
    let tagEls = tags.map(function (token, index) {
      return (<Tag key={index} token={token} textContent={stringHelper.truncate(token, 60, true)}
                   removeToken={removeTag}/>);
    });
    return (
      <div onClick={handeContainerClick} ref="container" className="simplecontainer simple tokencontainer">

        {tagEls}

        <input
          className="rt-tokenizer__user-input"
          ref="input"
          value={userInput}
          onBlur={handleBlur} onFocus={handleFocus} onKeyDown={handleKeyDown} onChange={handleTyping}/>
        {open && dropdownresults}
      </div>
    );
  }
}

TagsSuggest.propTypes = {
  tags: PropTypes.array.isRequired,
  onTagsChanged: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onEnter: PropTypes.func,
  loadingContent: PropTypes.bool
};

TagsSuggest.defaultProps = {
  onEnter: () => {
  }
};

export default TagsSuggest;



/** WEBPACK FOOTER **
 ** ./src/modules/search/components/TagsSuggest.js
 **/